import { FormGroup, FormBuilder } from '@angular/forms';
import { MatPaginator, MatSort, MatTable, MatTableDataSource } from '@angular/material';
import { ChangeDetectorRef, Component, OnDestroy, OnInit, QueryList, ViewChild, ViewChildren } from '@angular/core';
import { exportJsonToExcel } from 'app/shared/servifin-excel.export';
import { Subscription } from 'rxjs';
import { LineaAdquirenteService } from 'app/services/operaciones/linea-adquirente/linea-adquirente.service';
import { LineaAdquirente } from 'app/models/LineaAdquirente.model';
import Swal from 'sweetalert2';
import { HttpErrorResponse } from '@angular/common/http';
import { trigger, state, style, transition, animate } from '@angular/animations';
import { MessagesStatus, MessagesTitles } from 'app/models/messages';
import { Chart } from 'chart.js'
import ChartDataLabels from 'chartjs-plugin-datalabels';
import { environment } from 'environments/environment';
import { ActivatedRoute, Router } from '@angular/router';
import { LoginService } from 'app/services/login/login.service';
/* Register the plugin to all charts */
Chart.plugins.register(ChartDataLabels);

export enum ESTADO_LINEA {
  REGISTRADO = 'R',
  EN_EVALUACION = 'P',
  EVALUADO = 'E',
  BLOQUEADO = 'X',
  BAJA = 'B'
}

@Component({
  selector: 'app-lista-lineas',
  templateUrl: './lista-lineas.component.html',
  styleUrls: ['./lista-lineas.component.scss'],
  providers: [MessagesTitles, MessagesStatus],
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({ height: '0px', minHeight: '0' })),
      state('expanded', style({ height: '*' })),
      transition(
        'expanded <=> collapsed',
        animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')
      )
    ])
  ]
})
export class ListaLineasComponent implements OnInit, OnDestroy {

  Label_Proveedor=environment.LABEL_PROVEEDOR;
  Label_Proveedores=environment.LABEL_PROVEEDORES;
  Label_Adquirente=environment.LABEL_ADQUIRENTE;
  Label_Adquirentes=environment.LABEL_ADQUIRENTES;
  Label_id_soles=environment.ID_GUIA_SOLES;
  Label_id_dolares=environment.ID_GUIA_DOLARES;
  @ViewChild(MatPaginator, { static: true }) dataPaginator: MatPaginator;
  @ViewChildren('lineaPaginator') lineaPaginator: QueryList<MatPaginator>;

  @ViewChild('outerSort', { static: true }) sort: MatSort;
  @ViewChildren('innerSort') innerSort: QueryList<MatSort>;
  @ViewChildren('innerTables') innerTables: QueryList<MatTable<any>>;

  pageSizeOptions = [15, 20, 30, 50, 100, 200];
  displayedColumns = ['Accion', 'Nro', 'RUCAdquirente', 'Razon_Social', 'Moneda',
    'LineaAdmitida', 'LineaUtilizada', 'LineaDisponible', 'TipoServicio', 'SolicitadoPor',
    'Comentarios', 'EstadoLineaDetalleDsc', 'FechaRegistro', 'FechaEvaluacion', 'ArchivoPDF'];
  innerDisplayedColumns = ['LineaAdmitida', 'LineaUtilizada', 'LineaDisponible', 'SolicitadoPor',
    'Comentarios', 'EstadoLineaDetalleDsc'];
  dataSource: MatTableDataSource<LineaAdquirente>;
  lineaAdquirente: LineaAdquirente = {} as LineaAdquirente;
  lineasAdquirenteArr: any[] = [];
  loading: boolean = false;
  expandedElement: any | null;

  abrirDetalleLinea: boolean = false;
  valueFilter: string = '';
  sub: Subscription = new Subscription();
  formLinea: FormGroup;
  userActive: any;
  monedaSimbolo: string = '';
  IP: string = '192.168.1.1';
  adqFiltered: LineaAdquirente[] = [];

  textSwal: string;
  textConfirmBtnSwal: string;
  textConfirmService: string;
  textErrorService: string;

  lineaRazonSocialSoles: any = [];
  lineaAdmitidaSoles: any = [];
  lineaDisponibleSoles: any = [];
  barChartLineaAdquirenteSoles: any = [];
  lineaSoles: any = [];
  lineaRazonSocialDolares: any = [];
  lineaAdmitidaDolares: any = [];
  lineaDisponibleDolares: any = [];
  barChartLineaAdquirenteDolares: any = [];
  lineaDolares: any = [];
  updateChart: boolean = false;
  colorsSoles : any = [];
  colorsDolares : any = [];
  
  id = '';
  EmpresaNombre: any;
  readonly CANAL: string = 'W';

  constructor(
    private msgStatus: MessagesStatus,
    private msgTitulos: MessagesTitles,
    private cd: ChangeDetectorRef,
    private router: Router,
    private lineaAdquirenteService: LineaAdquirenteService,
    private fb: FormBuilder,
    private loginService: LoginService,
    private activateRoute :ActivatedRoute
  ) {
    this.userActive = JSON.parse(sessionStorage.getItem('UserActive'));
    const publicIpJson = sessionStorage.getItem('PUBLIC-IP');    
    this.EmpresaNombre = sessionStorage.getItem('razSocial');
    if (publicIpJson) {
      try {
        const parsedPublicIp = JSON.parse(publicIpJson);
        if (parsedPublicIp != null && parsedPublicIp.ip != null && String(parsedPublicIp.ip).trim() !== '') {
          this.IP = String(parsedPublicIp.ip);
        }
      } catch {
        /* mantener this.IP por defecto */
      }
    }
  }

  ngOnInit() {
    this.activateRoute.params.subscribe( params => {
      if(params['id']){
        this.id =params['id'];
        this.obtenerListaLineasAdquirenteById();
      }else{
        this.id='';
        this.obtenerListaLineasAdquirente();
      }
    })

    console.log("idid",this.id);
  }
  Regresar(){ 
    let id = sessionStorage.getItem('rucEmpresa');
    this.loginService.clickGuard = true;
    this.router.navigate(['/empresas/proveedor/listado/',id]);
  }
  ngOnDestroy() {
    this.sub.unsubscribe();
  }
  refresh(){
    this.updateChart = true;
    if(this.id == ''){
      this.obtenerListaLineasAdquirente();
    }else{
      this.obtenerListaLineasAdquirenteById();
    }
    
  }

  obtenerListaLineasAdquirente() {
    this.adqFiltered = [];
    this.lineasAdquirenteArr = [];

    let subItem: Subscription;
    this.loading = true;
    subItem = this.lineaAdquirenteService.obtenerListaLineasAdquirente().subscribe(
      (resList: any[]) => {
        sessionStorage.setItem('adqArr', JSON.stringify(resList));

        resList.forEach(linea => {
          if (linea.LineaAdquirenteDetalle && Array.isArray(linea.LineaAdquirenteDetalle) && linea.LineaAdquirenteDetalle.length) {
            linea.detalleLength = linea.LineaAdquirenteDetalle.length;
            this.lineasAdquirenteArr = [
              ...this.lineasAdquirenteArr,
              { ...linea, LineaAdquirenteDetalle: new MatTableDataSource(linea.LineaAdquirenteDetalle) }
            ];
          } else {
            this.lineasAdquirenteArr = [...this.lineasAdquirenteArr, linea];
          }
        });
        this.lineaSoles = [];
        this.lineaDolares = [];
        this.lineaSoles = this.lineasAdquirenteArr.filter(item => item.Moneda == this.Label_id_soles && item.Estado == 'E');
        this.lineaDolares = this.lineasAdquirenteArr.filter(item => item.Moneda == this.Label_id_dolares && item.Estado == 'E');
        
        if(this.id == ''){
          if (this.updateChart) {
            this.updateChartLineaSoles();
            this.updateChartLineaDolares();
          } else {
            for (let item of this.lineaSoles) {
              this.lineaRazonSocialSoles.push(item.Razon_Social);
              this.lineaAdmitidaSoles.push(Number(item.LineaAdmitida));
              this.lineaDisponibleSoles.push(Number(item.LineaDisponible));
            } 
            this.crearChartLineaSoles();

            for (let item of this.lineaDolares) {
              this.lineaRazonSocialDolares.push(item.Razon_Social);
              this.lineaAdmitidaDolares.push(Number(item.LineaAdmitida));
              this.lineaDisponibleDolares.push(Number(item.LineaDisponible));
            } 
            this.crearChartLineaDolares();
          }
        }        

        this.dataSource = new MatTableDataSource(this.lineasAdquirenteArr);
        this.dataSource.sort = this.sort;
        this.dataSource.paginator = this.dataPaginator;
        this.adqFiltered = this.lineasAdquirenteArr;
        this.loading = false;
      },
      (errRegistro: HttpErrorResponse) => {
        this.loading = false;
        this.msgStatus.getMessage(errRegistro.status);

        Swal.fire({
          title: this.msgTitulos.Error,
          text: "Lista no obtenida. " + this.msgStatus.message,
          type: "error",
          allowOutsideClick: true,
          heightAuto: false
        });
      }
    );

    this.sub.add(subItem);
  }

  obtenerListaLineasAdquirenteById() {
    this.adqFiltered = [];
    this.lineasAdquirenteArr = [];

    let subItem: Subscription;
    this.loading = true;
    subItem = this.lineaAdquirenteService.obtenerListaLineasAdquirenteById(this.id,1585).subscribe(
      (resList: any[]) => {
        sessionStorage.setItem('adqArr', JSON.stringify(resList));

        resList.forEach(linea => {
          if (linea.LineaAdquirenteDetalle && Array.isArray(linea.LineaAdquirenteDetalle) && linea.LineaAdquirenteDetalle.length) {
            linea.detalleLength = linea.LineaAdquirenteDetalle.length;
            this.lineasAdquirenteArr = [
              ...this.lineasAdquirenteArr,
              { ...linea, LineaAdquirenteDetalle: new MatTableDataSource(linea.LineaAdquirenteDetalle) }
            ];
          } else {
            this.lineasAdquirenteArr = [...this.lineasAdquirenteArr, linea];
          }
        });
        this.lineaSoles = [];
        this.lineaDolares = [];
        this.lineaSoles = this.lineasAdquirenteArr.filter(item => item.Moneda == this.Label_id_soles && item.Estado == 'E');
        this.lineaDolares = this.lineasAdquirenteArr.filter(item => item.Moneda == this.Label_id_dolares && item.Estado == 'E');
        
               

        this.dataSource = new MatTableDataSource(this.lineasAdquirenteArr);
        this.dataSource.sort = this.sort;
        this.dataSource.paginator = this.dataPaginator;
        this.adqFiltered = this.lineasAdquirenteArr;
        this.loading = false;
      },
      (errRegistro: HttpErrorResponse) => {
        this.loading = false;
        this.msgStatus.getMessage(errRegistro.status);

        Swal.fire({
          title: this.msgTitulos.Error,
          text: "Lista no obtenida. " + this.msgStatus.message,
          type: "error",
          allowOutsideClick: true,
          heightAuto: false
        });
      }
    );

    this.sub.add(subItem);
  }

  updateChartLineaSoles() {
    this.lineaRazonSocialSoles = [];
    this.lineaAdmitidaSoles = [];
    this.lineaDisponibleSoles = [];

    for (let item of this.lineaSoles) {
      this.lineaRazonSocialSoles.push(item.Razon_Social)
      this.lineaAdmitidaSoles.push(Number(item.LineaAdmitida))
      this.lineaDisponibleSoles.push(Number(item.LineaDisponible))
    }

    this.barChartLineaAdquirenteSoles.data.datasets[0].data = this.lineaAdmitidaSoles;
    this.barChartLineaAdquirenteSoles.data.datasets[1].data = this.lineaDisponibleSoles;
    this.barChartLineaAdquirenteSoles.data.datasets[1].backgroundColor = this.colorsSoles;
    this.barChartLineaAdquirenteSoles.config.options.scales.yAxes[0].ticks.max = this.lineaAdmitidaSoles.reduce((acc, value) => (acc > value) ? acc : value, 0) + 50000.00, // BUENA EDY
    this.barChartLineaAdquirenteSoles.data.labels = this.lineaRazonSocialSoles;
    this.barChartLineaAdquirenteSoles.update();
  }

  updateChartLineaDolares() {
    this.lineaRazonSocialDolares = [];
    this.lineaAdmitidaDolares = [];
    this.lineaDisponibleDolares = [];

    for (let item of this.lineaDolares) {
      this.lineaRazonSocialDolares.push(item.Razon_Social)
      this.lineaAdmitidaDolares.push(Number(item.LineaAdmitida))
      this.lineaDisponibleDolares.push(Number(item.LineaDisponible))
    }
    this.colorsDolares = [];
    for(let i = 0; i < this.lineaDisponibleDolares.length; i++){
      let colorCode = this.lineaDisponibleDolares[i] < 0 ? '#EF1A1A' : "#adf0ba";
      this.colorsDolares.push(colorCode);
    }

    this.barChartLineaAdquirenteDolares.data.datasets[0].data = this.lineaAdmitidaDolares;
    this.barChartLineaAdquirenteDolares.data.datasets[1].data = this.lineaDisponibleDolares;
    this.barChartLineaAdquirenteDolares.data.datasets[1].backgroundColor = this.colorsDolares;
    this.barChartLineaAdquirenteDolares.config.options.scales.yAxes[0].ticks.max = this.lineaAdmitidaDolares.reduce((acc, value) => (acc > value) ? acc : value, 0) + 50000.00, // BUENA EDY
    this.barChartLineaAdquirenteDolares.data.labels = this.lineaRazonSocialDolares;
    this.barChartLineaAdquirenteDolares.update();
  }

  toggleRow(element: any) {
    if (element.LineaAdquirenteDetalle && (element.LineaAdquirenteDetalle as MatTableDataSource<any>).data) {
      if (this.expandedElement === element) {
        this.expandedElement = null;
      } else {
        this.expandedElement = element;
      }
    } else {
      this.expandedElement = null;
    }
    this.cd.detectChanges();
    this.innerTables.forEach((table, index) => {
      (table.dataSource as MatTableDataSource<any>).sort = this.innerSort.toArray()[index];
      (table.dataSource as MatTableDataSource<any>).paginator = this.lineaPaginator.toArray()[index];
    });
  }

  applicarFiltroSubTabla(filterValue: string) {
    this.innerTables.forEach((table) =>
      (table.dataSource as MatTableDataSource<any>).filter = filterValue.trim().toLowerCase()
    );
  }

  aplicarFiltroGeneral(filterValue: string) {
    if (this.dataSource != null) {
      this.dataSource.filter = filterValue.trim().toLowerCase();
      this.adqFiltered = this.dataSource.filteredData;
    }
  }

  getTotalLineaAdmitida() {
    return this.adqFiltered.map(linea => +linea.LineaAdmitida).reduce((acc, value) => acc + value, 0);
  }

  getTotalLineaUtilizada() {
    return this.adqFiltered.map(linea => +linea.LineaUtilizada).reduce((acc, value) => acc + value, 0);
  }

  getTotalLineaDisponible() {
    return this.adqFiltered.map(linea => +linea.LineaDisponible).reduce((acc, value) => acc + value, 0);
  }

  exportarAExcel() {
    exportJsonToExcel(this.lineasAdquirenteArr, 'Lineas', 'Reporte_Lineas_Adquirente_');
  }

  armarBodyLineaAdq(lineaAdquirente: LineaAdquirente, estado: string) {
    this.formLinea = this.fb.group({
      idLineaAdquirente: lineaAdquirente.idLineaAdquirente,
      Estado: estado,
      TipoServicio: lineaAdquirente.TipoServicio,
      Moneda: lineaAdquirente.Moneda,
      Modificacion_Usuario: this.userActive.Usuario,
      ModificacionCanal: this.CANAL,
      IP: this.IP
    });
  }

  cambiarEstadoLinea(lineaAdq: LineaAdquirente, estado: string) {
    this.definirTextosSwal(lineaAdq, estado);

    Swal.fire({
      text: this.textSwal,
      type: 'warning',
      showCancelButton: true,
      cancelButtonText: 'No, cancelar',
      showConfirmButton: true,
      confirmButtonText: this.textConfirmBtnSwal,
      allowOutsideClick: false,
      reverseButtons: true,
      heightAuto: false
    }).then((result) => {
      if (result.value) {

        this.armarBodyLineaAdq(lineaAdq, estado);

        Swal.fire({
          title: 'Espere',
          text: 'Guardando los cambios',
          type: 'info',
          allowOutsideClick: false,
          heightAuto: false
        });
        Swal.showLoading();

        this.lineaAdquirenteService.cambiarDeEstadoLineaAdquirente(lineaAdq.idLineaAdquirente, this.formLinea.getRawValue()).subscribe(
          (resActualizacion: any) => {
            this.updateChart = true;
            this.obtenerListaLineasAdquirente();
            if (estado == ESTADO_LINEA.EN_EVALUACION) {

              Swal.fire({
                title: 'Éxito',
                text: this.textConfirmService,
                type: 'success',
                confirmButtonText: 'Ver Línea Adquirente',
                allowOutsideClick: false,
                heightAuto: false
              }).then((res) => {
                if (res.value) {
                  lineaAdq.Estado = ESTADO_LINEA.EN_EVALUACION;
                  lineaAdq.Modificacion_Fecha = resActualizacion.Modificacion_Fecha;
                  lineaAdq.Modificacion_Usuario = resActualizacion.Modificacion_Usuario;
                  this.verDetalle(lineaAdq);
                }
              });

            } else {

              Swal.fire({
                title: 'Éxito',
                text: this.textConfirmService,
                type: 'success',
                allowOutsideClick: false,
                heightAuto: false
              }).then((res) => {
                if (res.value) {
                  this.updateChart = true;
                }
              });

            }
          },
          (errRegistro: HttpErrorResponse) => {
            this.loading = false;
            this.msgStatus.getMessage(errRegistro.status);

            Swal.fire({
              title: this.msgTitulos.Error,
              text: "Línea no actualizada. " + this.msgStatus.message,
              type: "error",
              allowOutsideClick: true,
              heightAuto: false
            });
          }
        );
      }
    });
  }

  definirTextosSwal(lineaAdq: LineaAdquirente, estado: string) {
    if (estado == ESTADO_LINEA.EN_EVALUACION) {
      this.textSwal = '¿Iniciar evaluación de la línea de '+this.Label_Adquirente.toLowerCase()+'?';
      this.textConfirmBtnSwal = 'Si, iniciar evaluación';
      this.textConfirmService = 'La línea '+this.Label_Adquirente.toLowerCase()+' N° '.concat(lineaAdq.idLineaAdquirente.toString(), ' está lista para la evaluación.');
      this.textErrorService = 'Hubo un error a la hora de iniciar evaluación de la línea de '+this.Label_Adquirente.toLowerCase()+'. <br/>';
    } else if (estado == ESTADO_LINEA.EVALUADO) {
      this.textSwal = '¿Desbloquear la línea de '+this.Label_Adquirente.toLowerCase()+'?';
      this.textConfirmBtnSwal = 'Si, desbloquear';
      this.textConfirmService = '¡La línea '+this.Label_Adquirente.toLowerCase()+' N° '.concat(lineaAdq.idLineaAdquirente.toString(), ' ha sido desbloqueada!');
      this.textErrorService = 'Hubo un error a la hora de desbloquear la línea de '+this.Label_Adquirente.toLowerCase()+'. <br/>';
    } else if (estado == ESTADO_LINEA.BLOQUEADO) {
      this.textSwal = '¿Bloquear la línea de '+this.Label_Adquirente.toLowerCase()+'?';
      this.textConfirmBtnSwal = 'Si, bloquear';
      this.textConfirmService = '¡La línea '+this.Label_Adquirente.toLowerCase()+' N° '.concat(lineaAdq.idLineaAdquirente.toString(), ' ha sido bloqueada!');
      this.textErrorService = 'Hubo un error a la hora de bloquear la línea de '+this.Label_Adquirente.toLowerCase()+'. <br/>';
    } else if (estado == ESTADO_LINEA.BAJA) {
      this.textSwal = '¿Dar de baja la línea de '+this.Label_Adquirente.toLowerCase()+'?';
      this.textConfirmBtnSwal = 'Si, dar de baja';
      this.textConfirmService = '¡La línea '+this.Label_Adquirente.toLowerCase()+' N° '.concat(lineaAdq.idLineaAdquirente.toString(), ' se ha dado de baja!');
      this.textErrorService = 'Hubo un error a la hora de dar de baja la línea de '+this.Label_Adquirente.toLowerCase()+'. <br/>';
    }
  }

  crearNuevaLinea() {
    this.lineaAdquirente = null;
    this.abrirDetalleLinea = true;
  }

  verDetalle(element: any) {
    this.lineaAdquirente = element;
    this.abrirDetalleLinea = true;
  }

  obtenerPdf(urlPdf: string) {
    if (!urlPdf) {
      return;
    }
    Swal.fire({
      title: '',
      text: '¿Desea abrir el PDF de Aprobación de Cupo?',
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Sí, abrir PDF',
      cancelButtonText: 'No, cancelar',
      reverseButtons: true,
      heightAuto: false
    }).then((result) => {
      if (result.value) {
        window.open(urlPdf, '_blank');
      }
    });
  }

  crearChartLineaSoles() {
    for(let i = 0; i < this.lineaDisponibleSoles.length; i++){
      let colorCode = this.lineaDisponibleSoles[i] < 0 ? '#EF1A1A' : "#adf0ba";
      this.colorsSoles.push(colorCode);
    }
    this.barChartLineaAdquirenteSoles = new Chart('barChartLineaAdquirenteSoles', {
      type: 'bar',
      data: {
        labels: this.lineaRazonSocialSoles,
        datasets: [
          {
            label: 'LÍNEA ADMITIDA',
            data: this.lineaAdmitidaSoles,
            backgroundColor: ["#1a5429", "#1a5429", "#1a5429", "#1a5429", "#1a5429", "#1a5429", "#1a5429", "#1a5429", "#1a5429",
              "#1a5429", "#1a5429", "#1a5429", "#1a5429", "#1a5429", "#1a5429", "#1a5429", "#1a5429", "#1a5429", "#1a5429", "#1a5429",
              "#1a5429", "#1a5429", "#1a5429", "#1a5429"],
            borderWidth: 1,
            borderColor: '#ddd'
          },
          {
            label: 'LÍNEA DISPONIBLE',
            data: this.lineaDisponibleSoles,
            backgroundColor: this.colorsSoles,
            borderWidth: 1,
            borderColor: '#ddd'
          }
        ]
      },

      options: {
        responsive: true,
        hover: {
          animationDuration: 0
        },
        legend: {
          display: true,
          position: 'bottom',
          labels: {
            boxWidth: 20,
            fontColor: '#111',
            padding: 15
          }
        },
        tooltips: {
          enabled: true,
          callbacks: {
            label(t, d) {
              const xLabel = d.datasets[t.datasetIndex].label;
              const yLabel = t.yLabel >= 1000 ? t.yLabel.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') : t.yLabel;
              return xLabel + ': ' + yLabel;
            }
          }
        },
        scales: {
          yAxes: [
            {
              ticks: {
                beginAtZero: true,
                max: this.lineaAdmitidaSoles.reduce((acc, value) => (acc > value) ? acc : value, 0) + 50000.00, // PARA MANTENER UN MARGEN EN VERTICAL
                callback: (label: number) => {
                  return label.toFixed(0).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
                }
              }
            }
          ]
        },

        plugins: {
          datalabels: {
            color: 'blue',
            anchor: "end",
            align: "end",
            textAlign: 'center',
            font: {
              weight: 'bold',
              lineHeight: 1.8,
              size: 9
            },
            formatter: function (value) {
              return formatNumber(value, 2, ',', '.');
            }

          }
        },
      }
    });

    function formatNumber(number, decimalsLength, decimalSeparator, thousandSeparator) {
      var n = number;
      var decimalsLength2 = isNaN(decimalsLength = Math.abs(decimalsLength)) ? 2 : decimalsLength;
      var decimalSeparator2 = decimalSeparator == undefined ? "." : decimalSeparator;
      var thousandSeparator2 = thousandSeparator == undefined ? "," : thousandSeparator;
      var sign = n < 0 ? "-" : "";
      var i = parseInt(n = Math.abs(+n || 0).toFixed(decimalsLength)) + "";
      var j = (j = i.length) > 3 ? j % 3 : 0;

      return sign +
        (j ? i.substr(0, j) + thousandSeparator2 : "") +
        i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + thousandSeparator2) +
        (decimalsLength2 ? decimalSeparator2 + Math.abs(n - Number(i)).toFixed(decimalsLength2).slice(2) : "");
    }

    this.barChartLineaAdquirenteSoles.update();
  }

  crearChartLineaDolares() {
    for(let i = 0; i < this.lineaDisponibleDolares.length; i++){
      let colorCode = this.lineaDisponibleDolares[i] < 0 ? '#EF1A1A' : "#adf0ba";
      this.colorsDolares.push(colorCode);
    }

    this.barChartLineaAdquirenteDolares = new Chart('barChartLineaAdquirenteDolares', {
      type: 'bar',
      data: {
        labels: this.lineaRazonSocialDolares,
        datasets: [
          {
            label: 'LÍNEA ADMITIDA',
            data: this.lineaAdmitidaDolares,
            backgroundColor: ["#1a5429", "#1a5429", "#1a5429", "#1a5429", "#1a5429", "#1a5429", "#1a5429", "#1a5429", "#1a5429",
              "#1a5429", "#1a5429", "#1a5429", "#1a5429", "#1a5429", "#1a5429", "#1a5429", "#1a5429", "#1a5429", "#1a5429", "#1a5429",
              "#1a5429", "#1a5429", "#1a5429", "#1a5429"],
            borderWidth: 1,
            borderColor: '#ddd'
          },
          {
            label: 'LÍNEA DISPONIBLE',
            data: this.lineaDisponibleDolares,
            backgroundColor: this.colorsDolares,
            borderWidth: 1,
            borderColor: '#ddd'
          }
        ]
      },

      options: {
        responsive: true,
        hover: {
          animationDuration: 0
        },
        legend: {
          display: true,
          position: 'bottom',
          labels: {
            boxWidth: 20,
            fontColor: '#111',
            padding: 15
          }
        },
        tooltips: {
          enabled: true,
          callbacks: {
            label(t, d) {
              const xLabel = d.datasets[t.datasetIndex].label;
              const yLabel = t.yLabel >= 1000 ? t.yLabel.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') : t.yLabel;
              return xLabel + ': ' + yLabel;
            }
          }
        },
        scales: {
          yAxes: [
            {
              ticks: {
                beginAtZero: true,
                max: this.lineaAdmitidaDolares.reduce((acc, value) => (acc > value) ? acc : value, 0) + 50000.00, // PARA MANTENER UN MARGEN EN VERTICAL
                callback: (label: number) => {
                  return label.toFixed(0).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
                }
              }
            }
          ]
        },

        plugins: {
          datalabels: {
            color: 'blue',
            anchor: "end",
            align: "end",
            textAlign: 'center',
            font: {
              weight: 'bold',
              lineHeight: 1.8,
              size: 9
            },
            formatter: function (value) {
              return formatNumber(value, 2, ',', '.');
            }

          }
        },
      }
    });

    function formatNumber(number, decimalsLength, decimalSeparator, thousandSeparator) {
      var n = number;
      var decimalsLength2 = isNaN(decimalsLength = Math.abs(decimalsLength)) ? 2 : decimalsLength;
      var decimalSeparator2 = decimalSeparator == undefined ? "." : decimalSeparator;
      var thousandSeparator2 = thousandSeparator == undefined ? "," : thousandSeparator;
      var sign = n < 0 ? "-" : "";
      var i = parseInt(n = Math.abs(+n || 0).toFixed(decimalsLength)) + "";
      var j = (j = i.length) > 3 ? j % 3 : 0;

      return sign +
        (j ? i.substr(0, j) + thousandSeparator2 : "") +
        i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + thousandSeparator2) +
        (decimalsLength2 ? decimalSeparator2 + Math.abs(n - Number(i)).toFixed(decimalsLength2).slice(2) : "");
    }

    this.barChartLineaAdquirenteDolares.update();
  }

  cerrarPopUp() {
    this.abrirDetalleLinea = false;
  }
}
